import { css } from '@emotion/react';
import { SecurityCard } from '@/components/page-sections/SecurityCard';
import { getScreen } from '@/styles/media-query';
import { withPrefix } from 'gatsby';

export type SecuritySectionProps = {
  className?: string;
};

export const SecuritySection: React.FC<SecuritySectionProps> = ({
  className,
}) => {
  return (
    <section
      css={css`
        padding: 48px 0 88px;

        @media ${getScreen('pc')} {
          padding: 80px 20px 120px;
        }
      `}
      className={className}
    >
      {/* 社名変更による再審査のため非表示 */}
      {/* <h2
        css={css`
          text-align: center;
          font: normal normal bold 16px/42px 'Noto Sans JP', sans-serif;
          letter-spacing: 1.1px;
          color: #00b3a7;
          margin-bottom: 32px;

          @media ${getScreen('pc')} {
            font: normal normal bold 22px/42px 'Noto Sans JP', sans-serif;
            letter-spacing: 1.52px;
            margin-bottom: 56px;
          }
        `}
      >
        組織的な対策
      </h2>
      <div
        css={css`
          max-width: 290px;
          margin: 0 auto;
          padding-bottom: 72px;

          @media ${getScreen('pc')} {
            max-width: 998px;
            padding-bottom: 96px;
          }
        `}
      >
        <ToolIsoCard />
      </div> */}
      <h2
        css={css`
          text-align: center;
          font: normal normal bold 16px/42px 'Noto Sans JP', sans-serif;
          letter-spacing: 1.1px;
          color: #00b3a7;
          margin-bottom: 32px;

          @media ${getScreen('pc')} {
            font: normal normal bold 22px/42px 'Noto Sans JP', sans-serif;
            letter-spacing: 1.52px;
            margin-bottom: 56px;
          }
        `}
      >
        技術的な対策
      </h2>
      <ul
        css={css`
          display: grid;
          gap: 40px;
          max-width: 290px;
          margin: 0 auto;

          @media ${getScreen('pc')} {
            max-width: 998px;
            grid-template-columns: repeat(2, 1fr);
            gap: 50px;
          }
        `}
      >
        {[
          {
            head: <>通信の安全化（SSL）</>,
            text: `ブラウザとサーバー間のデータ通信を暗号化します。暗号化通信により、サイト利用ユーザーの個人情報やログイン情報を、第三者の盗聴から守り、改ざんやなりすましから個人情報を保護します。`,
            imageSrc: withPrefix('/images/security/security-icon-1.png'),
          },
          {
            head: <>WAFの導入</>,
            text: `ウェブの脆弱性を利用した攻撃やボットから、アプリケーションやAPIを保護するために、AWS WAFを採用しています。サイバーセキュリティクラウド社のWafCharmを適用し、独自にカスタマイズしたルールを構築、運用しています。`,
            imageSrc: withPrefix('/images/security/security-icon-2.png'),
          },
          {
            head: (
              <>
                サーバーレス
                <br />
                アーキテクチャの採用
              </>
            ),
            text: `サーバーを持たないため、OSやソフトウェアの脆弱性対応などが不要となり、常にAWSが最新の状態に保たれ、セキュリティリスクが低減されます。`,
            imageSrc: withPrefix('/images/security/security-icon-3.png'),
          },
          {
            head: <>脆弱性検査</>,
            text: (
              <>
                リリース前にGSX<sup>※</sup>
                のタイガーチームによる大規模なペネトレーションテストを実施し、定期的な診断を実施しています。悪意ある攻撃や情報漏えい事故などのリスクを未然に防ぐことができます。
              </>
            ),
            imageSrc: withPrefix('/images/security/security-icon-4.png'),
            caution: (
              <>
                ※GSX…グローバルセキュリティエキスパート株式会社&nbsp;
                <a
                  href="https://www.gsx.co.jp/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://www.gsx.co.jp/
                </a>
              </>
            ),
          },
          {
            head: (
              <>
                データベース
                <br />
                セキュリティの最大化
              </>
            ),
            text: `データベースへのアクセスをIAM認証による暗号通信とすることでセキュリティを担保しています。さらにデータベース自身も非公開領域(Private-Sub net) に配置し、情報漏えいを防止しています。`,
            imageSrc: withPrefix('/images/security/security-icon-5.png'),
          },
          {
            head: <>Cognito Authorizerの採用</>,
            text: `ユーザーのログイン認証でも利用しているAmazon Cognitoと連携するCognito Authorizer をAPI Gatewayに適用し、API Gatewayの不正利用を防ぐことでセキュリティ強化を実現しています。`,
            imageSrc: withPrefix('/images/security/security-icon-6.png'),
          },
        ].map((item, i) => (
          <li key={i}>
            <SecurityCard {...item} />
          </li>
        ))}
      </ul>
    </section>
  );
};
